import { StatusBadge } from '@/components/common/StatusBadge';
import { LEAVE_TYPE_TONE } from '../constants/leaveApplication.constants';

interface LeaveTypeBadgeProps {
  leaveTypeName: string;
}

export function LeaveTypeBadge({ leaveTypeName }: LeaveTypeBadgeProps) {
  return <StatusBadge tone={LEAVE_TYPE_TONE}>{leaveTypeName}</StatusBadge>;
}
